/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popRef.vue?vue&type=template&id=bb3ac99a&scoped=true"
import script from "./popRef.vue?vue&type=script&lang=js"
export * from "./popRef.vue?vue&type=script&lang=js"
import style0 from "./popRef.vue?vue&type=style&index=0&id=bb3ac99a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3ac99a",
  null
  
)

export default component.exports